import type { IModuleData } from '../';

export interface IInstanceData {
  id?: string;
  learningObjectId?: string;
  name: string;
  dateCreated: string;
  isDefault: boolean;
  isFlexible: boolean;
  completionDeadline: string;
  enrollmentDeadline: string;
  state: InstanceStateTypes;
  modules: IModuleData[];
  subInstances?: IInstanceData[];
}

export enum InstanceStateTypes {
  Active = 'Active',
  Retired = 'Retired'
}

export interface IInstance extends IInstanceData {
  isDeadlinePassed: boolean;
  isActive: boolean;
  subInstances?: IInstance[];
  validate(): void;
}
